
import axios from "axios";
import { Square } from "lucide-react";
import * as Config from "../../Utils/Config";
const api = axios.create({
  // baseURL: "https://trade.tradestreet.in/backend/",
  // baseURL: "http://localhost:8800/",
    baseURL: Config.base_url,
  headers: {
    "Content-Type": "application/json",
  },
});


const ApiService = {

  // ---------------- AUTH ----------------
  login: (email, password, fcmToken) =>
    api.post("login", { UserName: email, password, fcm_token: fcmToken }),

  googleLogin: (id_token, fcm_token, ReferredBy, email) =>
    api.post("googleLogin", { id_token, fcm_token, ReferredBy, email }),

  register: (data) => api.post("SignIn", data),

  logout: (user_id) => api.post("logoutUser", { userid: user_id }),

  // ---------------- MPIN ----------------
  generateMPin: (user_id, pin) =>
    api.post("user/generateMPin", { user_id, pin }),

  matchPin: (user_id, pin) =>
    api.post("user/matchPin", { user_id, pin }),

  changeMpin: (data) => api.post("user/changePin", data),

  forgotMpin: (data) => api.post("user/ForgotPin", data),

  // ---------------- USER ----------------
  getUserDetail: (user_id) =>
    api.post("getUserDetail", { userid: user_id }),

  getFavorites: (user_id) => api.post("getFavouritelist ", {userid: user_id }),

  updateUserDocument: (data) =>
    api.post("updateUserDocument", data),

  getUserDocuments: (user_id) =>
    api.post("getUserDocuments", { userId: user_id }),

  // ---------------- SYMBOL / WATCHLIST ----------------
  symbolList: (payload) =>
    api.post("users/userSymbollist", payload),

  symbolListInr: (payload) =>
    api.post("user-symbols", payload),


  symbolsmodallist: (payload) =>
    api.post("symbols", payload),

  addSymbol: (payload) =>
    api.post("users/addSymbol", payload),
  addInrSymbol: (payload) =>
    api.post("add-symbol", payload),

  deleteSymbol: (payload) =>
    api.post("users/deletwatchlistsymbol", payload),

  deleteSymbolInr: (payload) =>
    api.post("delete-symbol", payload),

  addFavoriteInr: (payload) => api.post("add-favorite-symbol", payload),

  removeFavoriteInr: (payload) => api.post("remove-favorite-symbol", payload),

  addFavoriteUsd: (payload) =>
    api.post("Favouritelist", payload),

  removeFavoriteUsd: (payload) =>
    api.post("removeFavourite", payload),

  removeModallist: (payload) =>
    api.post("delete-symbol", payload),

  SearchSymbol: (payload) =>
    api.post("users/symbolSearch", payload),

  deleteSymbolUsd: (payload) =>
    api.post("users/deletwatchlistsymbol", payload),

  //--------------------Position-------------------
  PositionInr: (payload) =>
    api.post("inr-position", payload),

  HoldingInr: (payload) =>
    api.post("inr-holding", payload),

  PositionUsd: (payload) =>
    api.post("position", payload),

  HoldingUsd: (payload) =>
    api.post("holding", payload),

  viewStatement: (payload) =>
    api.post("tradeStatementForOrder", payload),

  SquareoffInr: (payload) =>
    api.post("square-off", payload),

  SquareoffUsd: (payload) =>
    api.post("Squareoff", payload),
  // ---------------- MARKET / RESEARCH ----------------
  getGraph: (symbol) => api.get(`api/prices?symbol=${symbol}`),

  getResearch: (id, type) =>
    api.get(`admin/getresearch?id=${id}&type=${type}`),

  indexSymbols: () => api.post("index-symbols"),

  topSymbols: (type) => api.post("top-symbols", { type }),

  optionSymbolSearch: (symbol) =>
    api.post("option-symbol", symbol),

  optionSymbolExpiry: (symbol) =>
    api.post("option-symbol-expiry", symbol),

  optionRoundToken: (data) =>
    api.post("option-all-round-token", data),

  getExpiry: () => api.get("getexpiry"),

  createStrike: (data) => api.post("cretestrike", data),

  // ---------------- ORDER / TRADE ----------------
  placeOrder: (data) => api.post("users/placeorder", data),

  placeOrderInr: (data) => api.post("place-order", data),

  squareOff: (data) => api.post("Squareoff", data),

  squareOffInr: (data) => api.post("square-off", data),

  getOrderBook: (data) => api.post("getOrderBook", data),

  getOrderBookInr: (data) => api.post("order-book", data),

  deletePendingOrderInr: (data) =>
    api.post("deleteInrPendingOrder", data),


  deletePendingOrder: (data) =>
    api.post("deletePendingOrder", data),

  updatePendingOrder: (data) =>
    api.post("updateInrPendingOrder", data),

  updatePendingOrderUsd: (data) =>
    api.post("updatePendingOrder", data),

  convertPosition: (data) =>
    api.post("convertPosition", data),

  convertPositionInr: (data) =>
    api.post("convert-position", data),

  // ---------------- PAYMENT / WALLET ----------------
  withdrawalDeposit: (data) =>
    api.post("userWithdrawalanddeposite", data),

  withdrawalDepositInr: (data) =>
    api.post("user-withdrawal-deposite", data),

  paymentHistory: (payload) =>
    api.post("getpaymenthistory", payload),

  paymentHistoryInr: (data) =>
    api.post("payment-history", data),

  fundConverter: (data) =>
    api.post("transfer-history", data),

  transferHistory: (userId) =>
    api.post("get-transfer-history", { userid: userId }),

  ledgerReport: (data) =>
    api.post("getledgerreport", data),

  balanceStatement: (data) =>
    api.post("balanceStatementForUser", data),

  balanceStatementInr: (data) =>
    api.post("balance-statement", data),

  // ---------------- NOTIFICATIONS ----------------
  todaysBroadcastMessage: (userId) =>
    api.post("todaysBroadcastMessage", { userId }),

  // ---------------- BANK ----------------
  getUserBank: (userId) =>
    api.post("getUserAccountDetails ", userId),

  setPrimaryBank: (id) =>
    api.post("admin/setPrimaryBank", id),

  deleteBank: (id) =>
    api.post("admin/deleteBankDetails", id),

  addBank: (data) =>
    api.post("updateUserAccountDetails", data),

  updateBank: (data) =>
    api.post("admin/updateBankDetails", data),

  adminGetUpi: (id) =>
    api.post("admin/getUpiDetails", { id }),

  // ---------------- CHAT ----------------
  getConversationId: (data) =>
    api.post("admin/conversation", data),

  getMessages: (id) =>
    api.get(`admin/messages/${id}`),

  sendMessage: (data) =>
    api.post("admin/message", data),

  // ---------------- MISC ----------------
  getCompany: () => api.get("getCompany"),

  getMarginValue: (user_id) =>
    api.post("getmarginvalue", { userid: user_id }),

  downloadApk: () => api.post("Downloadapk"),

  getUpdateVersion: () => api.post("getupdatevertion", {}),

  getReferralCode: (userid) =>
    api.post("admin/getreferralcode", { userId: userid }),

  stopLossUpdate: (data) =>
    api.post("UpdateTargetSlPRice", data),

  stopLossUpdateInr: (data) =>
    api.post("update-target-sl", data),




  //--------------------tradeStatement-------------------
  getStatementforuser: (payload) => api.post("tradeStatementForUser ", payload),


  tradeStatementForOrder: (payload) => api.post("tradeStatementForOrder ", payload),


  //dashboard data
  getFavroritelist: (payload) => api.post("getFavouritelist  ", payload),
  getFavroritelistInr: (payload) => api.post("get-favorite-symbols   ", payload),

  getMarketList: (payload) => api.post("top-symbols", payload),















};

export default ApiService;




